import { Controller } from "@hotwired/stimulus"

// Controller for managing seasonal reference times on the night allowance
// (Nachtzulage / time_based_split). Handles adding/removing season rows.
// The field-editor controller reads the rows during serialization via the
// ".seasonal-row" class and the data-seasonal-field attributes.
export default class extends Controller {
  static targets = ["rowsContainer", "row"]

  static values = {
    translations: Object,
  }

  // Get translation with fallback
  t(key) {
    return this.translationsValue[key] || key
  }

  // Add a new season row
  addSeason() {
    const newRow = document.createElement("div")
    newRow.className = "flex flex-wrap items-end gap-2 seasonal-row"
    newRow.dataset.seasonalConfigsTarget = "row"

    newRow.innerHTML = `
      <div>
        <label class="block text-xs text-gray-500 mb-1">${this.t("from_month")}</label>
        <input type="number" data-seasonal-field="from_month" min="1" max="12" value="1" autocomplete="off"
               class="w-16 shadow-xs sm:text-sm border-gray-300 rounded-md focus:ring-green-500 focus:border-green-500">
      </div>
      <div>
        <label class="block text-xs text-gray-500 mb-1">${this.t("from_day")}</label>
        <input type="number" data-seasonal-field="from_day" min="1" max="31" value="1" autocomplete="off"
               class="w-16 shadow-xs sm:text-sm border-gray-300 rounded-md focus:ring-green-500 focus:border-green-500">
      </div>
      <div>
        <label class="block text-xs text-gray-500 mb-1">${this.t("to_month")}</label>
        <input type="number" data-seasonal-field="to_month" min="1" max="12" value="12" autocomplete="off"
               class="w-16 shadow-xs sm:text-sm border-gray-300 rounded-md focus:ring-green-500 focus:border-green-500">
      </div>
      <div>
        <label class="block text-xs text-gray-500 mb-1">${this.t("to_day")}</label>
        <input type="number" data-seasonal-field="to_day" min="1" max="31" value="31" autocomplete="off"
               class="w-16 shadow-xs sm:text-sm border-gray-300 rounded-md focus:ring-green-500 focus:border-green-500">
      </div>
      <div>
        <label class="block text-xs text-gray-500 mb-1">${this.t("reference_time_from")}</label>
        <input type="time" data-seasonal-field="reference_time_from" value="06:00" autocomplete="off"
               class="shadow-xs sm:text-sm border-gray-300 rounded-md focus:ring-green-500 focus:border-green-500">
      </div>
      <div>
        <label class="block text-xs text-gray-500 mb-1">${this.t("reference_time_to")}</label>
        <input type="time" data-seasonal-field="reference_time_to" value="20:00" autocomplete="off"
               class="shadow-xs sm:text-sm border-gray-300 rounded-md focus:ring-green-500 focus:border-green-500">
      </div>
      <button type="button"
              class="p-1 mb-1 text-gray-400 hover:text-red-500"
              data-action="click->seasonal-configs#removeSeason"
              title="${this.t("remove")}">
        <svg class="h-4 w-4" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor">
          <path fill-rule="evenodd" d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z" clip-rule="evenodd" />
        </svg>
      </button>
    `

    this.rowsContainerTarget.appendChild(newRow)
  }

  // Remove a season row
  removeSeason(event) {
    const row = event.target.closest(".seasonal-row")
    if (row) {
      row.remove()
    }
  }
}
